import React, { useEffect, useState } from 'react';
import moment from 'moment';
import DeleteModal from '../../utils/deleteModal/deleteModal';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import services from '../../services';
import { GET_ALL_USER } from '../../utils/Apifunction';
import { FiLayout } from 'react-icons/fi';
import AddBoardModal from './AddBoard';
import Select from "react-select";
import { Switch } from '@mui/material';
import { styles } from './BoardManage.styles';
import PageHeader from '../../common/PageHeader';
import TablePagination from '../../common/TablePagination';
import { MdDeleteOutline, MdAdd } from 'react-icons/md';

const BoardManage = () => {
    const [userData, setUserData] = useState([]);
    const [editData, setEditData] = useState('');
    const [editId, setEditId] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [showModalDelete, setShowModalDelete] = useState(false);
    const [selectDeleteId, setSelectDeleteId] = useState('');
    const [addUserStatus, setAddUserStatus] = useState(false);
    const [searchUserData, setSearchUserData] = useState('');
    const [sortProducts, setSortProducts] = useState({ key: 'createdAt', direction: 'desc' });
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const pageSize = 10;
    const [boardName, setBoardName] = useState(false);
    const navigate = useNavigate();

    const getLoggedInUser = () => {
        try {
            const raw = localStorage.getItem('userData');
            if (!raw) return null;
            const parsed = JSON.parse(raw);
            return typeof parsed === 'string' ? JSON.parse(parsed) : parsed;
        } catch (e) {
            console.error('Invalid userData in localStorage', e);
            return null;
        }
    };

    const loggedInUser = getLoggedInUser();

    const handleStatusToggle = async (item) => {
        try {
            await services.user.UPDATE_USER(item?.id, { status: !item?.status });
            toast.success(`${item?.name}'s status updated successfully!`);
            GET_ALL_USER_DATA();
        } catch (e) {
            toast.error('Failed to update status!');
            console.error(e);
        }
    };

    const handleEdit = (data) => {
        setEditData(data);
        setAddUserStatus(true);
        setEditId(data?.id);
    };

    const handleDelete = async () => {
        try {
            await services.board.DELETE_BOARD(selectDeleteId);
            toast.success('Board deleted successfully!');
            GET_ALL_USER_DATA();
        } catch (e) {
            const rawMessage = e?.response?.data?.message || '';
            const cleanMessage = rawMessage.replace(/^Error deleting board:\s*/i, '');
            toast.error(cleanMessage || 'Failed to delete board!');
            console.error(e);
        }
    };

    const getAllLinkedEmail = async () => {
        try {
            const response = await services.email.Get_The_Linked_Email();
            if (response) {
                const options = response?.data?.map((email) => ({
                    label: email.email,
                    value: email.id,
                    color: email.colour,
                }));
                setGmailUsers(options);
            }
        } catch (error) {
            console.error('error');
        }
    };

    const handleConfirmDelete = () => {
        setShowModalDelete(false);
        handleDelete();
    };

    useEffect(() => {
        GET_ALL_USER_DATA();
        getAllLinkedEmail();
    }, [searchUserData, sortProducts, currentPage]);

    const GET_ALL_USER_DATA = async () => {
        if (loggedInUser?.role === 'User') {
            try {
                const response = await services.userassignboard.GET_UserAssignBoard_ID(loggedInUser?.id);
                const assignedBoards = response?.data?.data || [];

                let boards = assignedBoards
                    .filter((item) => item?.Board)
                    .map((item) => ({
                        id: item.Board.id,
                        boardName: item.Board.boardName,
                        createdAt: item.Board.createdAt,
                        status: item.Board.status,
                    }));

                if (searchUserData) {
                    boards = boards.filter((b) =>
                        b.boardName?.toLowerCase().includes(searchUserData.toLowerCase())
                    );
                }

                boards.sort((a, b) => {
                    const dir = sortProducts.direction === 'asc' ? 1 : -1;
                    if (a[sortProducts.key] < b[sortProducts.key]) return -1 * dir;
                    if (a[sortProducts.key] > b[sortProducts.key]) return 1 * dir;
                    return 0;
                });

                const totalPagesCount = Math.max(1, Math.ceil(boards.length / pageSize));
                const paged = boards.slice((currentPage - 1) * pageSize, currentPage * pageSize);

                setUserData(paged);
                setTotalPages(totalPagesCount);
            } catch (e) {
                console.error('Failed to fetch assigned boards!', e);
            }
            return;
        }

        const object = {
            page: currentPage,
            search: searchUserData,
            sortBy: sortProducts.key,
            sortOrder: sortProducts.direction,
            pageSize: pageSize,
        };
        const query = new URLSearchParams(object).toString();
        const response = await services.board.GETALLBOARD(query);
        if (response) {
            setUserData(response?.data || []);
            setTotalPages(response?.totalPages || 1);
        }
    };

    function handleSort(key) {
        setSortProducts((prev) => {
            if (prev.key === key) {
                return { key, direction: prev.direction === 'asc' ? 'desc' : 'asc' };
            }
            return { key, direction: 'asc' };
        });
        setCurrentPage(1);
    }

    function renderSortIcon(key) {
        if (sortProducts.key !== key) return null;
        return sortProducts.direction === 'asc' ? ' ▲' : ' ▼';
    }

    const [selectedEmailsByUser, setSelectedEmailsByUser] = useState({});

    const handleArchivePermission = async (item) => {
        try {
            await services.user.UPDATE_USER(item?.id, { isPermission: !item?.isPermission });
            toast.success(`${item?.name}'s archive permission updated successfully!`);
            GET_ALL_USER_DATA();
        } catch (e) {
            toast.error('Failed to update archive permission!');
            console.error(e);
        }
    };

    const handleAssingUser = async (userId, selectedEmails) => {
        try {
            await services.user.UPDATE_USER(userId, {
                usersEmailMapped: selectedEmails ?? []
            });
            toast.success(`Archive permissions updated successfully!`);
            GET_ALL_USER_DATA();
        } catch (e) {
            toast.error('Failed to update archive permission!');
            console.error(e);
        }
    };

    const handleEmailChange = (userId, selected) => {
        setSelectedEmailsByUser(prev => ({
            ...prev,
            [userId]: selected || []
        }));
        handleAssingUser(userId, selected);
    };

    useEffect(() => {
        if (Array.isArray(userData)) {
            const mapped = {};
            userData.forEach(user => {
                mapped[user.id] = user.usersEmailMapped || [];
            });
            setSelectedEmailsByUser(mapped);
        }
    }, [userData]);

    return (
        <div style={styles.pageWrapper}>

            {/* ── Page Header ── */}
            <PageHeader
                onBack={() => navigate('/app')}
                icon={<FiLayout size={18} color="#fff" />}
                title="Board Management"
                count={userData.length > 0 ? userData.length : undefined}
            />

            {/* ── Table Card ── */}
            <div style={styles.tableCard}>
                <div style={styles.tableScroll}>
                    <table style={styles.table}>
                        <thead>
                            <tr style={styles.theadRow}>
                                <th style={styles.thNoSort}>No.</th>
                                <th
                                    style={styles.th}
                                    onClick={() => handleSort('name')}
                                >
                                    Board Name{renderSortIcon('name')}
                                </th>
                                <th
                                    style={styles.th}
                                    onClick={() => handleSort('createdAt')}
                                >
                                    Create Date{renderSortIcon('createdAt')}
                                </th>
                                <th style={styles.thNoSort}>Status</th>
                                <th style={styles.thNoSort}>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {userData.length === 0 ? (
                                <tr>
                                    <td colSpan="5">
                                        <div style={styles.emptyState}>
                                            <FiLayout size={38} color="#d1d5db" />
                                            <p style={styles.emptyText}>No boards found.</p>
                                        </div>
                                    </td>
                                </tr>
                            ) : (
                                userData.map((item, index) => (
                                    <tr
                                        key={item.id}
                                        style={styles.row}
                                        onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#f0fdf4'; }}
                                        onMouseLeave={e => { e.currentTarget.style.backgroundColor = '#fff'; }}
                                    >
                                        <td style={styles.indexCell}>
                                            {(currentPage - 1) * pageSize + index + 1}
                                        </td>

                                        <td style={styles.td}>
                                            <div style={styles.boardNameCell}>
                                                <div style={styles.boardIcon}>
                                                    {item?.boardName?.charAt(0)?.toUpperCase() || 'B'}
                                                </div>
                                                <span style={styles.boardNameText}>{item?.boardName}</span>
                                            </div>
                                        </td>

                                        <td style={styles.td}>
                                            <span style={styles.dateBadge}>
                                                {moment(item?.createdAt).format('DD MMM YYYY')}
                                            </span>
                                        </td>

                                        <td style={styles.statusCell}>
                                            <Switch
                                                checked={Boolean(item.status)}
                                                size="small"
                                                sx={{
                                                    '& .MuiSwitch-switchBase.Mui-checked': { color: '#1a7d3e' },
                                                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: '#1a7d3e' },
                                                }}
                                            />
                                        </td>

                                        <td>
                                            <div style={styles.actionGroup}>
                                                <button
                                                    style={styles.btnAdd}
                                                    title="Edit Board Name "
                                                    onMouseEnter={e => { e.currentTarget.style.background = '#d1fae5'; e.currentTarget.style.borderColor = '#86efac'; }}
                                                    onMouseLeave={e => { e.currentTarget.style.background = '#f0fdf4'; e.currentTarget.style.borderColor = '#d1fae5'; }}
                                                    onClick={() => {
                                                        setBoardName(item?.boardName);
                                                        setShowModal(true);
                                                        setEditId(item?.id);
                                                    }}
                                                >
                                                    <MdAdd size={18} />
                                                </button>
                                                {item?.boardName !== 'Housekeeping' && (
                                                <button
                                                    style={styles.btnDelete}
                                                    title="Delete Board"
                                                    onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#fee2e2'; }}
                                                    onMouseLeave={e => { e.currentTarget.style.backgroundColor = '#fff5f5'; }}
                                                    onClick={() => {
                                                        setShowModalDelete(true);
                                                        setSelectDeleteId(item.id);
                                                    }}
                                                >
                                                    <MdDeleteOutline fontSize={17} />
                                                </button>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* ── Pagination ── */}
            <div style={{ marginTop: '20px' }}>
                <TablePagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPrev={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                    onNext={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                />
            </div>

            {showModal && (
                <AddBoardModal
                    show={showModal}
                    onHide={() => setShowModal(false)}
                    getAllBoard={GET_ALL_USER_DATA}
                    editId={editId}
                    setBoardName={boardName}
                    setEditId={setEditId}
                />
            )}

            <DeleteModal
                showModal={showModalDelete}
                handleCloseModal={() => setShowModalDelete(false)}
                handleConfirm={handleConfirmDelete}
                confirmButtonName="Delete"
                title="Delete Board"
                message="Are you sure you want to delete this Board?"
            />
        </div>
    );
};

export default BoardManage;
